export const TestIds = {
  additionalFilter: {
    container: 'ces-additionalFilter-container',
    searchForm: 'ces-additionalFilter-searchForm',
    filters: 'ces-additionalFilter-filters',
    hideFiltersButton: 'ces-additionalFilter-hideFiltersButton',
    filterLabels: {
      oneToOne: 'ces-filter-oneToOne-label',
      interactionType: 'ces-filter-interactionType-label',
      promo: 'ces-filter-promo-label',
      products: 'ces-filter-products-label',
      indication: 'ces-filter-indication-label',
      fieldForce: 'ces-filter-fieldForce-label',
      emailChannels: 'ces-filter-emailChannels-label',
      emailCampaign: 'ces-filter-emailCampaign-label',
      emailTopic: 'ces-filter-emailTopic-label',
      websitePortal: 'ces-filter-websitePortal-label',
      eventType: 'ces-filter-eventType-label',
      eventName: 'ces-filter-eventName-label',
      interactionTypeAllChannels: 'ces-filter-interactionTypeAllChannels-label',
    },
  },
};
